import React, { useState } from 'react';
import { Alert, Box, Card, CardContent, Tab, Tabs } from '@mui/material';
import { useAccessControl } from '../../hooks/useAccessControl';
import { RESOURCES, ACTIONS } from '../../hooks/usePermissions';
import ModulePageHeader from '../common/ModulePageHeader';
import ItemsTab from './inventory/ItemsTab';
import ReceiptsTab from './inventory/ReceiptsTab';
import IssuesTab from './inventory/IssuesTab';
import AdjustmentsTab from './inventory/AdjustmentsTab';
import InvTransfersTab from './inventory/InvTransfersTab';
import RevaluationsTab from './inventory/RevaluationsTab';
import InventoryReportsTab from './inventory/InventoryReportsTab';

const TABS = [
  { value: 'items', label: 'Items', Component: ItemsTab },
  { value: 'receipts', label: 'Receipts', Component: ReceiptsTab },
  { value: 'issues', label: 'Issues', Component: IssuesTab },
  { value: 'adjustments', label: 'Adjustments', Component: AdjustmentsTab },
  { value: 'transfers', label: 'Transfers', Component: InvTransfersTab },
  { value: 'revaluations', label: 'Revaluations', Component: RevaluationsTab },
  { value: 'reports', label: 'Reports', Component: InventoryReportsTab },
];

// Inventory: consumable/sellable stock (config/ledger.php section
// 'inventory') - the stewardship mirror of Fixed Assets (which tracks
// individual physical assets, this tracks fungible quantities). Items own
// the master; every movement follows DRAFT -> APPROVED -> POSTED.
const Inventory = () => {
  const { can } = useAccessControl();
  const [tab, setTab] = useState('items');

  if (!can(RESOURCES.LEDGER.INVENTORY, ACTIONS.READ)) {
    return <Alert severity="error">You do not have permission to view Inventory.</Alert>;
  }

  const Active = TABS.find((t) => t.value === tab)?.Component;

  return (
    <Box>
      <ModulePageHeader
        title="Inventory"
        subtitle="Stock items, receipts, issues, adjustments, transfers and valuation"
      />
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ pb: '8px !important', pt: '4px !important' }}>
          <Tabs value={tab} onChange={(_, v) => v && setTab(v)} variant="scrollable" scrollButtons="auto">
            {TABS.map((t) => (
              <Tab key={t.value} value={t.value} label={t.label} />
            ))}
          </Tabs>
        </CardContent>
      </Card>

      {Active && <Active />}
    </Box>
  );
};

export default Inventory;
